import { fetchWrapperPortal } from './fetch';

export interface NotificationCampaign {
  _id?: string;
  name?: string;
  type?: string;
  recipients?: string[];
  [key: string]: any;
}

export interface Notification {
  _id?: string;
  title?: string;
  message?: string;
  type?: string;
  userId?: string;
  read?: boolean;
  [key: string]: any;
}

// Create a new notification campaign
export const createCampaign = async (campaignData: Partial<NotificationCampaign>): Promise<NotificationCampaign> => {
  return await fetchWrapperPortal<NotificationCampaign>({
    url: 'notifications/campaigns',
    method: 'POST',
    body: JSON.stringify(campaignData),
    addBearer: true,
  });
};

// Get all notification campaigns (admin view)
export const getAllCampaigns = async (): Promise<NotificationCampaign[]> => {
  return await fetchWrapperPortal<NotificationCampaign[]>({
    url: `notifications/campaigns`,
    method: 'GET',
    addBearer: true,
  });
};

// Update an existing notification campaign
export const updateCampaign = async (
  campaignId: string,
  campaignData: Partial<NotificationCampaign>
): Promise<NotificationCampaign> => {
  return await fetchWrapperPortal<NotificationCampaign>({
    url: `notifications/campaigns/${campaignId}`,
    method: 'PUT',
    body: JSON.stringify(campaignData),
    addBearer: true,
  });
};

// Get all users for recipient selection
export const getUsersForNotification = async (): Promise<any> => {
  return await fetchWrapperPortal({
    url: `users?fields=_id,display_name,email`,
    method: 'GET',
    addBearer: true,
  });
};

// Send notification to users
export const sendNotification = async (notificationData: Partial<Notification>): Promise<any> => {
  return await fetchWrapperPortal({
    url: `notifications/send`,
    method: `POST`,
    body: JSON.stringify(notificationData),
    addBearer: true,
  });
};

// Get all notifications (admin view)
export const getAllNotifications = async (): Promise<Notification[]> => {
  return await fetchWrapperPortal<Notification[]>({
    url: `notifications/admin/all`,
    method: `GET`,
    addBearer: true,
  });
};

// Get user notifications (for notification panel)
export const getUserNotifications = async (userId: string): Promise<Notification[]> => {
  return await fetchWrapperPortal<Notification[]>({
    url: `notifications/user/${userId}`,
    method: `GET`,
    addBearer: true,
  });
};

// Mark notification as read
export const markAsRead = async (notificationId: string, userId: string): Promise<any> => {
  return await fetchWrapperPortal({
    url: `notifications/${notificationId}/read`,
    method: `POST`,
    body: JSON.stringify({ userId }),
    addBearer: true,
  });
};

// Mark notification as inactive (admin)
export const markAsInactive = async (notificationId: string): Promise<any> => {
  return await fetchWrapperPortal({
    url: `notifications/${notificationId}/inactive`,
    method: `PUT`,
    addBearer: true,
  });
};

// Get notification stats (read/unread counts and user details)
export const getNotificationStats = async (notificationId: string): Promise<any> => {
  return await fetchWrapperPortal({
    url: `notifications/${notificationId}/stats`,
    method: `GET`,
    addBearer: true,
  });
};

// Schedule notification for later
export const scheduleNotification = async (notificationData: Partial<Notification>): Promise<any> => {
  return await fetchWrapperPortal({
    url: `notifications/schedule`,
    method: `POST`,
    body: JSON.stringify(notificationData),
    addBearer: true,
  });
};

// Legacy/existing functions that were already being used in the codebase
export const getFilters = async (): Promise<any> => {
  return await fetchWrapperPortal({
    url: `notifications/filters`,
    method: `GET`,
    addBearer: true,
  });
};

export const sendStreamNotification = async (streamData: any): Promise<any> => {
  return await fetchWrapperPortal({
    url: `notifications/stream`,
    method: `POST`,
    body: JSON.stringify(streamData),
    addBearer: true,
  });
};

export const sendEventNotification = async (eventData: any): Promise<any> => {
  return await fetchWrapperPortal({
    url: `notifications/event`,
    method: `POST`,
    body: JSON.stringify(eventData),
    addBearer: true,
  });
};
